import { makeBox, MakeBoxProps } from "../../components/layout";
import { ReactComponent as Archive } from "./assets/Archive.svg";
import { ReactComponent as ArrowDown } from "./assets/ArrowDown.svg";
import { ReactComponent as ArrowElbowDownLeft } from "./assets/ArrowElbowDownLeft.svg";
import { ReactComponent as Bird } from "./assets/Bird.svg";
import { ReactComponent as Book } from "./assets/Book.svg";
import { ReactComponent as BookmarksSimple } from "./assets/BookmarksSimple.svg";
import { ReactComponent as Books } from "./assets/Books.svg";
import { ReactComponent as Calculator } from "./assets/Calculator.svg";
import { ReactComponent as CalendarBlank } from "./assets/CalendarBlank.svg";
import { ReactComponent as CalendarChecked } from "./assets/CalendarChecked.svg";
import { ReactComponent as CaretDoubleDown } from "./assets/CaretDoubleDown.svg";
import { ReactComponent as CaretDoubleUp } from "./assets/CaretDoubleUp.svg";
import { ReactComponent as ChalkboardTeacher } from "./assets/ChalkboardTeacher.svg";
import { ReactComponent as Chart } from "./assets/Chart.svg";
import { ReactComponent as Chat } from "./assets/Chat.svg";
import { ReactComponent as ChatsCircle } from "./assets/ChatsCircle.svg";
import { ReactComponent as ChevronDown } from "./assets/ChevronDown.svg";
import { ReactComponent as ChevronLeft } from "./assets/ChevronLeft.svg";
import { ReactComponent as ChevronRight } from "./assets/ChevronRight.svg";
import { ReactComponent as CircleWavyCheck } from "./assets/CircleWavyCheck.svg";
import { ReactComponent as Clock } from "./assets/Clock.svg";
import { ReactComponent as Cross } from "./assets/Close.svg";
import { ReactComponent as Cog } from "./assets/Cog.svg";
import { ReactComponent as Copy } from "./assets/Copy.svg";
import { ReactComponent as DotsHorizontal } from "./assets/DotsHorizontal.svg";
import { ReactComponent as DotsVertical } from "./assets/DotsVertical.svg";
import { ReactComponent as DownloadFile } from "./assets/DownloadFile.svg";
import { ReactComponent as Edit } from "./assets/Edit.svg";
import { ReactComponent as Envelope } from "./assets/Envelope.svg";
import { ReactComponent as ExamQuestion } from "./assets/ExamQuestion.svg";
import { ReactComponent as ExclamationCircle } from "./assets/ExclamationCircle.svg";
import { ReactComponent as Export } from "./assets/Export.svg";
import { ReactComponent as Eye } from "./assets/Eye.svg";
import { ReactComponent as EyeSlashed } from "./assets/EyeSlashed.svg";
import { ReactComponent as Filters } from "./assets/Filters.svg";
import { ReactComponent as Globe } from "./assets/Globe.svg";
import { ReactComponent as GraduationCap } from "./assets/GraduationCap.svg";
import { ReactComponent as Group } from "./assets/Group.svg";
import { ReactComponent as HamburgerMenu } from "./assets/HamburgerMenu.svg";
import { ReactComponent as Heart } from "./assets/Heart.svg";
import { ReactComponent as Help } from "./assets/Help.svg";
import { ReactComponent as House } from "./assets/House.svg";
import { ReactComponent as Info } from "./assets/Info.svg";
import { ReactComponent as KeyReturn } from "./assets/KeyReturn.svg";
import { ReactComponent as Leave } from "./assets/Leave.svg";
import { ReactComponent as LightBulb } from "./assets/LightBulb.svg";
import { ReactComponent as Lightning } from "./assets/Lightning.svg";
import { ReactComponent as LightningOutline } from "./assets/LightningOutline.svg";
import { ReactComponent as Lock } from "./assets/Lock.svg";
import { ReactComponent as Medal } from "./assets/Medal.svg";
import { ReactComponent as Megaphone } from "./assets/Megaphone.svg";
import { ReactComponent as Dash } from "./assets/Minus.svg";
import { ReactComponent as Moon } from "./assets/Moon.svg";
import { ReactComponent as MoonStars } from "./assets/MoonStars.svg";
import { ReactComponent as Muscle } from "./assets/Muscle.svg";
import { ReactComponent as NonCalculator } from "./assets/NonCalculator.svg";
import { ReactComponent as NotePencil } from "./assets/NotePencil.svg";
import { ReactComponent as PeoplePair } from "./assets/PeoplePair.svg";
import { ReactComponent as PersonIcon } from "./assets/Person.svg";
import { ReactComponent as Play } from "./assets/Play.svg";
import { ReactComponent as Plus } from "./assets/Plus.svg";
import { ReactComponent as PlusCircle } from "./assets/PlusCircle.svg";
import { ReactComponent as ReadMore } from "./assets/ReadMore.svg";
import { ReactComponent as Reassign } from "./assets/Reassign.svg";
import { ReactComponent as Robot } from "./assets/Robot.svg";
import { ReactComponent as Rocket } from "./assets/Rocket.svg";
import { ReactComponent as School } from "./assets/School.svg";
import { ReactComponent as Search } from "./assets/Search.svg";
import { ReactComponent as Send } from "./assets/Send.svg";
import { ReactComponent as Seneca } from "./assets/Seneca.svg";
import { ReactComponent as SenecaLoader } from "./assets/SenecaLoader.svg";
import { ReactComponent as Share } from "./assets/Share.svg";
import { ReactComponent as Shuffle } from "./assets/Shuffle.svg";
import { ReactComponent as Skip } from "./assets/Skip.svg";
import { ReactComponent as SmileyXEyes } from "./assets/SmileyXEyes.svg";
import { ReactComponent as Squares } from "./assets/Squares.svg";
import { ReactComponent as Star } from "./assets/Star.svg";
import { ReactComponent as Stopwatch } from "./assets/Stopwatch.svg";
import { ReactComponent as Student } from "./assets/Student.svg";
import { ReactComponent as Sun } from "./assets/Sun.svg";
import { ReactComponent as SunHorizon } from "./assets/SunHorizon.svg";
import { ReactComponent as Synced } from "./assets/Synced.svg";
import { ReactComponent as Target } from "./assets/Target.svg";
import { ReactComponent as Tick } from "./assets/Tick.svg";
import { ReactComponent as TickCircle } from "./assets/TickCircle.svg";
import { ReactComponent as Transfer } from "./assets/Transfer.svg";
import { ReactComponent as Trash } from "./assets/Trash.svg";
import { ReactComponent as Warning } from "./assets/Warning.svg";
import { ReactComponent as WhatsApp } from "./assets/WhatsApp.svg";

export const iconNameMap: {
  [key in IconName]: (props: MakeBoxProps) => JSX.Element;
} = {
  archive: makeBox(Archive),
  arrowDown: makeBox(ArrowDown),
  arrowElbowDownLeft: makeBox(ArrowElbowDownLeft),
  bird: makeBox(Bird),
  book: makeBox(Book),
  bookmarksSimple: makeBox(BookmarksSimple),
  books: makeBox(Books),
  calculator: makeBox(Calculator),
  calendarBlank: makeBox(CalendarBlank),
  calendarChecked: makeBox(CalendarChecked),
  caretDoubleDown: makeBox(CaretDoubleDown),
  caretDoubleUp: makeBox(CaretDoubleUp),
  chalkboardTeacher: makeBox(ChalkboardTeacher),
  chart: makeBox(Chart),
  chat: makeBox(Chat),
  chatsCircle: makeBox(ChatsCircle),
  chevronDown: makeBox(ChevronDown),
  chevronLeft: makeBox(ChevronLeft),
  chevronRight: makeBox(ChevronRight),
  circleWavyCheck: makeBox(CircleWavyCheck),
  clock: makeBox(Clock),
  cog: makeBox(Cog),
  copy: makeBox(Copy),
  cross: makeBox(Cross),
  dash: makeBox(Dash),
  dotsHorizontal: makeBox(DotsHorizontal),
  dotsVertical: makeBox(DotsVertical),
  downloadFile: makeBox(DownloadFile),
  edit: makeBox(Edit),
  envelope: makeBox(Envelope),
  examQuestion: makeBox(ExamQuestion),
  exclamationCircle: makeBox(ExclamationCircle),
  export: makeBox(Export),
  eye: makeBox(Eye),
  eyeSlashed: makeBox(EyeSlashed),
  filters: makeBox(Filters),
  globe: makeBox(Globe),
  graduationCap: makeBox(GraduationCap),
  group: makeBox(Group),
  hamburgerMenu: makeBox(HamburgerMenu),
  heart: makeBox(Heart),
  help: makeBox(Help),
  house: makeBox(House),
  info: makeBox(Info),
  keyReturn: makeBox(KeyReturn),
  leave: makeBox(Leave),
  lightbulb: makeBox(LightBulb),
  lightning: makeBox(Lightning),
  lightningOutline: makeBox(LightningOutline),
  lock: makeBox(Lock),
  medal: makeBox(Medal),
  megaphone: makeBox(Megaphone),
  moon: makeBox(Moon),
  moonStars: makeBox(MoonStars),
  muscle: makeBox(Muscle),
  nonCalculator: makeBox(NonCalculator),
  notePencil: makeBox(NotePencil),
  peoplePair: makeBox(PeoplePair),
  person: makeBox(PersonIcon),
  play: makeBox(Play),
  plus: makeBox(Plus),
  plusCircle: makeBox(PlusCircle),
  readMore: makeBox(ReadMore),
  reassign: makeBox(Reassign),
  rocket: makeBox(Rocket),
  robot: makeBox(Robot),
  school: makeBox(School),
  search: makeBox(Search),
  send: makeBox(Send),
  seneca: makeBox(Seneca),
  senecaLoader: makeBox(SenecaLoader),
  share: makeBox(Share),
  shuffle: makeBox(Shuffle),
  skip: makeBox(Skip),
  smileyXEyes: makeBox(SmileyXEyes),
  squares: makeBox(Squares),
  star: makeBox(Star),
  stopwatch: makeBox(Stopwatch),
  student: makeBox(Student),
  sun: makeBox(Sun),
  sunHorizon: makeBox(SunHorizon),
  synced: makeBox(Synced),
  target: makeBox(Target),
  tick: makeBox(Tick),
  tickCircle: makeBox(TickCircle),
  transfer: makeBox(Transfer),
  trash: makeBox(Trash),
  warning: makeBox(Warning),
  whatsapp: makeBox(WhatsApp)
};

export type IconName =
  | "archive"
  | "arrowDown"
  | "arrowElbowDownLeft"
  | "bird"
  | "book"
  | "bookmarksSimple"
  | "books"
  | "calculator"
  | "calendarBlank"
  | "calendarChecked"
  | "caretDoubleDown"
  | "caretDoubleUp"
  | "chalkboardTeacher"
  | "chart"
  | "chat"
  | "chatsCircle"
  | "chevronDown"
  | "chevronLeft"
  | "chevronRight"
  | "circleWavyCheck"
  | "clock"
  | "cog"
  | "copy"
  | "cross"
  | "dash"
  | "dotsHorizontal"
  | "dotsVertical"
  | "downloadFile"
  | "edit"
  | "envelope"
  | "examQuestion"
  | "exclamationCircle"
  | "export"
  | "eye"
  | "eyeSlashed"
  | "filters"
  | "globe"
  | "graduationCap"
  | "group"
  | "hamburgerMenu"
  | "heart"
  | "help"
  | "house"
  | "info"
  | "keyReturn"
  | "leave"
  | "lightbulb"
  | "lightning"
  | "lightningOutline"
  | "lock"
  | "medal"
  | "megaphone"
  | "moon"
  | "moonStars"
  | "muscle"
  | "nonCalculator"
  | "notePencil"
  | "peoplePair"
  | "person"
  | "play"
  | "plus"
  | "plusCircle"
  | "readMore"
  | "reassign"
  | "rocket"
  | "robot"
  | "school"
  | "search"
  | "send"
  | "seneca"
  | "senecaLoader"
  | "share"
  | "shuffle"
  | "skip"
  | "smileyXEyes"
  | "squares"
  | "star"
  | "stopwatch"
  | "student"
  | "sun"
  | "sunHorizon"
  | "synced"
  | "target"
  | "tick"
  | "tickCircle"
  | "transfer"
  | "trash"
  | "warning"
  | "whatsapp";
